























import Vue from 'vue';
import { signInWithGoogle } from '@/repository/auth';

export default Vue.extend({
  methods: {
    signGoogle() {
      signInWithGoogle().then((result) => {
        this.$store.dispatch('fetchUser', result.user);
        this.$router.replace('/dashboard');
      });
    },
  },
});

